module.exports = __webpack_public_path__ + "img/information.c4d817fc.svg";